import React from "react";
import Translator from "Languages/Utility/Translator";
import PageTitle from "Components/PageTitle_IconCircle/PageTitle";
import TblTickets from "./components/TblTickets";

export default function TicketsIndex() {
 
  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <PageTitle title={<Translator id="sami_tickets" />} />
      </div>
      <TblTickets />
    </>
  );
}
